import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { useCurrentChatGroupContext } from "hooks/useCurrentChatGroupContext";
import { useFormikContext } from "formik";
import { MultiValue, SingleValue } from "react-select";
import { CustomField } from "../customField.types";
import { OnLabelResolved } from "../customFieldSelector.types";
import {
  getSelectedComboboxOption,
  resolveSelectedOptionLabel,
} from "../customFieldSelector.utils";

type EntitySelectorFieldProps = {
  field: CustomField;
  name: string;
  disabled?: boolean;
  onLabelResolved?: OnLabelResolved;
};

export const EntitySelectorField = ({
  field,
  name,
  disabled,
  onLabelResolved,
}: EntitySelectorFieldProps) => {
  const { entities } = useCurrentChatGroupContext();
  const { values } = useFormikContext<Record<string, string | string[]>>();

  const options: OptionData[] = entities.map(({ uuid, name: entityName }) => ({
    label: entityName,
    value: uuid,
  }));
  const selectedOption = getSelectedComboboxOption(
    options,
    values[name],
    field.is_multi_select
  );

  const handleChange = (
    option: SingleValue<OptionData> | MultiValue<OptionData>
  ) => {
    const label = resolveSelectedOptionLabel(option);
    if (label) {
      onLabelResolved?.(name, label);
    }
  };

  return (
    <Combobox
      withForm
      name={name}
      label={field.label}
      placeholder={field.placeholder}
      required={field.is_required}
      tooltipText={field.tooltip}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      isMulti={field.is_multi_select}
      isDisabled={disabled}
      menuPortalTarget={document.body}
    />
  );
};
